var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"color-picker-pipette",attrs:{"src":require("@/assets/icons/color-picker-pipette.svg"),"alt":_vm.$t('redactor.pipette__button')},on:{"click":_vm.togglePipette}})])
}
var staticRenderFns = []

export { render, staticRenderFns }